/**
 * DayArc — the day as five steps: Plan · Prime · Do · Review · Rest.
 * Dots fill as the day happens; each is tappable. Deep Rest becomes two
 * steps in the day rather than a separate feature.
 */

import { Sun, Sunrise, ListChecks, Moon, Sparkles } from 'lucide-react';

const STEPS = [
  { key: 'plan', label: 'Plan', Icon: Sun },
  { key: 'prime', label: 'Prime', Icon: Sunrise },
  { key: 'do', label: 'Do', Icon: ListChecks },
  { key: 'review', label: 'Review', Icon: Sparkles },
  { key: 'rest', label: 'Rest', Icon: Moon },
];

export default function DayArc({ state = {}, current, onTap, className = '' }) {
  return (
    <div id="day-arc" className={`flex items-center justify-between ${className}`} role="list" aria-label="Your day">
      {STEPS.map((step, i) => {
        const done = !!state[step.key];
        const isCurrent = current === step.key;
        const Icon = step.Icon;
        return (
          <div key={step.key} className="flex items-center flex-1 min-w-0" role="listitem">
            <button
              onClick={() => onTap?.(step.key)}
              className="flex flex-col items-center gap-1 flex-shrink-0"
              aria-current={isCurrent ? 'step' : undefined}
            >
              <span className={`w-8 h-8 rounded-full border flex items-center justify-center transition-colors ${
                done ? 'bg-indigo-600 border-indigo-500 text-white'
                  : isCurrent ? 'border-indigo-400 text-indigo-300 bg-indigo-900/30'
                    : 'border-slate-700 text-slate-500'}`}>
                <Icon size={14} />
              </span>
              <span className={`text-[10px] ${isCurrent || done ? 'text-slate-200' : 'text-slate-500'}`}>{step.label}</span>
            </button>
            {i < STEPS.length - 1 && (
              <span className={`flex-1 h-px mx-1.5 mb-4 ${done ? 'bg-indigo-700/60' : 'bg-slate-800'}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
